<template>
  <div v-if="total" class="countries">
    <div ref="chart" class="country-chart" role="img" :aria-label="`客户国家分布，共${total}人`" />
    <ul class="country-legend"><li v-for="(row,index) in rows" :key="row.name"><span><i :style="{background:colours[index%colours.length]}" />{{ row.name }}</span><b>{{ row.value }} 人 <small>{{ (Number(row.value)/total*100).toFixed(1) }}%</small></b></li></ul>
  </div>
  <a-empty v-else description="暂无客户国家数据" />
</template>
<script>
import { init, use } from 'echarts/core'
import { PieChart } from 'echarts/charts'
import { TooltipComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
use([PieChart, TooltipComponent, CanvasRenderer])
export default {
  name: 'CustomerCountries', props: { rows: { type: Array, default: () => [] } },
  data: () => ({ colours: ['#237b67','#708fbe','#b394c0','#d7ae71','#8995a6','#77b3ad','#b99a7c'] }),
  computed: { total () { return this.rows.reduce((sum,row) => sum+Number(row.value || 0),0) } },
  watch: { rows: { deep: true, handler () { this.$nextTick(this.render) } } },
  mounted () { this.render(); window.addEventListener('resize',this.resize); if(window.ResizeObserver){this.observer=new ResizeObserver(this.resize);this.observer.observe(this.$el)} },
  beforeDestroy () { window.removeEventListener('resize',this.resize);if(this.observer)this.observer.disconnect();if(this.chart)this.chart.dispose() },
  methods: {
    resize () { if(this.chart)this.chart.resize() },
    render () {
      if(!this.total || !this.$refs.chart){if(this.chart){this.chart.dispose();this.chart=null}return}
      if(!this.chart)this.chart=init(this.$refs.chart)
      this.chart.setOption({color:this.colours,tooltip:{trigger:'item',renderMode:'richText',confine:true,formatter:'{b}: {c} 人 ({d}%)'},series:[{type:'pie',radius:['48%','76%'],label:{show:false},data:this.rows.map(row=>({name:row.name,value:Number(row.value)}))}]},true)
    }
  }
}
</script>
<style scoped>
.countries{display:flex;align-items:center;gap:16px;min-width:0}.country-chart{height:230px;width:42%;min-width:130px}.country-legend{list-style:none;padding:0;margin:0;flex:1;max-height:230px;overflow:auto;min-width:0}.country-legend li{display:flex;justify-content:space-between;gap:8px;padding:9px 0;font-size:12px;border-bottom:1px solid #f1f3f5}.country-legend span{overflow-wrap:anywhere}.country-legend i{display:inline-block;width:7px;height:7px;border-radius:50%;margin-right:6px}.country-legend b{font-weight:500;white-space:nowrap}.country-legend small{color:#8a929e;margin-left:5px}@media(max-width:500px){.countries{flex-direction:column}.country-chart{width:100%;height:190px}.country-legend{width:100%}}
</style>
